import styled from "styled-components";

const GlobalErr = styled.div`
    background: ${props => props.theme.red};
    color:  ${props => props.theme.white};
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    .error-wrapper {
        max-width: 120rem;
        margin: 0 auto;
        padding: 1.5rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    p {
        line-height: 1rem;
    }
    span {
        display: block;
        font-size: 1.2rem;
        margin-bottom: 0;
    }
    button {
        width: 3rem;
        height: 3rem;
    }
`;

const RefreshLink = styled.a`
    cursor: pointer;
    font-family: ${props => props.theme.fontBold};
    color: ${props => props.theme.white};
    text-decoration: underline;
`;

export { GlobalErr, RefreshLink };
